export enum BookingsTab {
  CURRENT = 'En cours',
  COMPLETED = 'Terminées',
}
